export const CONSTANTS = {
  MIN_ZOOM: 3,
  MAX_ZOOM: 22
} as const